import { atom } from 'jotai';

export interface GrondGebruik {
  title: string;
  fosfaatKey: string;
  grondKey: string;
}

export const grondGebruiken = atom<GrondGebruik[]>([
  { title: 'Grasland', fosfaatKey: 'graslandOppervlakte', grondKey: 'grasland' },
  { title: 'Natuurgrasland', fosfaatKey: 'natuurgraslandOppervlakte', grondKey: 'natuurgrasland' },
  { title: 'Snijmais', fosfaatKey: 'snijmaisOppervlakte', grondKey: 'snijmaisland' },
  { title: 'Akkerbouw', fosfaatKey: 'akkerbouwOppervlakte', grondKey: 'akkerbouw' },
]);

export const fosfaatSoorten = atom(get => get(grondGebruiken).map(item => item.fosfaatKey));
export const grondSoorten = atom(get => get(grondGebruiken).map(item => item.grondKey));
export const onbekendId = atom(6);
